import { render, staticRenderFns } from "./NewPaymentDocuments.vue?vue&type=template&id=97f32352&scoped=true"
import script from "./NewPaymentDocuments.vue?vue&type=script&lang=js"
export * from "./NewPaymentDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f32352",
  null
  
)

export default component.exports